// ======================================================================
// File Name       : HtmlDialog
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { Form, FormControl, Col, Button, Modal, Table } from 'react-bootstrap';
import PaginationCustom from '../../Pagination';
import { MODAL_SIZE } from '../../../constants/index';

class HtmlDialog extends Component {
  render() {
    const { show, redirectUri } = this.props;
    if (!redirectUri) {
      return null;
    }
    return (
      <Modal
        show={show}
        animation={false}
        size={MODAL_SIZE.lg}
      >
        <Modal.Header onHide={this.props.closeDialog} closeButton />
        <Modal.Body>
          <Col sm={12} className="margin-top-10">
            <div className="borderSolid0pxHalf">
              <iframe
                title="result_dialog"
                src={redirectUri}
                width="100%"
                height="400"
              />
            </div>
          </Col>
        </Modal.Body>
        <Modal.Footer className="text-center">
          <Button key={1} className="btn-96" onClick={this.props.closeDialog}>
            {'OK'}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default HtmlDialog;
